/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

const Section = styled.section`
  border: 0px solid #dadce0;

  color: #FFFFFF;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
  
  //background-size: 0 0 !important;
  //background-color: #2c5967;
  background-image: url(${props => props.bgImagePath && props.bgImagePath});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: ${props => props.bgImageOffset && props.bgImageOffset};
  
  width: 100%;
  min-height: 260px;
  height: calc(33.3333vh - 20px);
  
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-end;
`;
const InnerSection = styled.div`
  border: 0px solid;

  box-sizing: border-box;
  width: 1140px;
  @media (max-width: 1140px) {
    width: 960px;
  }
  @media (max-width: 980px) {
    width: 800px;
  }
  @media (max-width: 820px) {
    width: 640px;
  }
  @media (max-width: 660px) {
    width: 100%;
    background-color: rgb(0,0,0,0.6);
    align-items: flex-start;
    text-align: left;
  }
  margin-left: auto;
  margin-right: auto;
`;
const CssFlexleft = css`  
  display: flex;
  flex-flow: column nowrap;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: start;
  align-items: flex-start;
  text-align: left;
`;
const CssFlexRight = css`  
  display: flex;
  flex-flow: column nowrap;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: start;
  align-items: flex-end;
  text-align: right;
`;
const TextBox = styled.div`
  max-width: 560px;
  padding: 16px 24px;
  box-sizing: border-box;
  @media (max-width: 660px) {
    text-shadow: 0px 0px 0px #000000;
  }
`;
const CssTextShadowNone = css`
  text-shadow: 0px 0px 0px #000000;
`;
const CssTextShadowWeak = css`
  text-shadow: 0px 0px 22px #000000;
`;
const HeaderText = styled.h2`
  font-weight: 100;
  line-height: 1.15;
  font-size: 45px;
  @media (max-width: 660px) {
    font-size: 32px;
  }
  margin-top: 0px;
  margin-bottom: 24px;
`;
const CssHeaderTextBold = css`
  display: block;
  font-size: 1.1em;
  font-weight: 800;
  line-height: 1.2;
  margin-top: -1px;
`;

class GraphicSectionMidsize extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    let info = this.props.info;
    console.log("'info'",info);
    let key = info.key;
    let bgImagePath = info.bgImagePath;
    let bgImageOffset = info.bgImageOffset;
    let subTitle = info.subTitle;
    let mainTitle = info.mainTitle;
    let keyWord = info.keyWord;
    let alignRight = info.alignRight;
    let textShadow = info.textShadow;

    let detailsLink = `/details/${key}`;

    let CssInnerSection = alignRight ? CssFlexRight : CssFlexleft;
    console.log("'alignRight'",alignRight);
    console.log("'CssInnerSection'",CssInnerSection);

    let CssTextBox = textShadow ? CssTextShadowWeak : CssTextShadowNone;
    console.log("'alignRight'",alignRight);
    console.log("'CssInnerSection'",CssInnerSection);

    return (
      <div className="GraphicSectionMidsize" id="SectionTop">

        <Section className="section" bgImagePath={bgImagePath} bgImageOffset={bgImageOffset}>
          <InnerSection className="InnerSection" css={CssInnerSection}>
            <Link to={detailsLink}>
              <TextBox  className="text-box" css={CssTextBox}>
                <HeaderText className="header-text">{subTitle} <b css={CssHeaderTextBold}>{mainTitle}</b></HeaderText>
                <div>{keyWord}</div>
              </TextBox>
            </Link>
          </InnerSection>
        </Section>

      </div>
    );
  }
}

export default GraphicSectionMidsize;
